import _ from "lodash";

import Vue from "vue";
import { mapGetters } from "vuex";

// Icons
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// Mixins
import { formatDateTime, inputValidateState, paginationMixin, stringHelper } from "@/components/mixins/";

// Components
import { LoadingSpinner } from "@/components";

// Serices
import { ErrorLogService, GridUtil, ObjectUtil, PartListService } from "@/services";

// Types
import { IQuickOrdersContext } from "../../QuickOrders.types";

export default Vue.extend({
  name: "PartListTab",
  mixins: [formatDateTime, inputValidateState, paginationMixin, stringHelper],
  components: {
    FontAwesomeIcon,
    LoadingSpinner,
  },
  props: {
    context: {
      type: Object,
      default: () => ObjectUtil.createInstance<IQuickOrdersContext>(),
    },
  },
  computed: {
    ...mapGetters(["getContentItem"]),
  },
  data: () => ({
    columns: [
      { key: "PartListName", localizationKey: "ListName", sortable: true },
      { key: "PartCount", localizationKey: "NumberOfItems", sortable: true },
      { key: "ModifiedDate", localizationKey: "LastModified", sortable: true, formatter: "formatDateTime" },
    ],
    listName: "",
    isBusy: false,
    textFilter: null,
    plusIcon: faPlus,
    activeView: "DEFAULT",
  }),
  created() {
    this.columns = GridUtil.localizeColumnLabels(this.columns, this.getContentItem);
    this.pagination.perPage = 5;

    const dictionary = {
      en: {
        attributes: {
          listName: "Part List Name",
        },
      },
    };

    this.$validator.localize(dictionary);
  },
  methods: {
    async loadList() {
      const ctx = this.context as IQuickOrdersContext;

      const params = {
        accountId: ctx.accountId,
        userId: ctx.user.UserId,
        numberItemsToReturn: 500
      };

      try {
        const rows = await PartListService.GetPartListSummary(params);

        this.pagination.totalRows = rows.length;

        return rows;
      } catch (err) {
        ErrorLogService.LogException(err);
        return [];
      }
    },

    async submitAddNewList() {
      try {
        const formIsValid = await this.$validator.validateAll();

        if (!formIsValid) {
          return;
        }

        this.isBusy = true;

        const ctx = this.context as IQuickOrdersContext;

        const partListName = _.trim(this.listName);

        const request = {
          accountId: ctx.accountId,
          userId: ctx.user.UserId,
          partListName,
        };

        await PartListService.CreateNewPartList(request);

        this.$store.commit("pushTimedMessage", {
          header: "Successfully created new part list",
          IsError: false,
          seconds: 5,
        });

        await this.loadList();

        this.showDefaultView();
      } catch {
        this.$store.commit("pushTimedMessage", {
          header: "Error creating new part list",
          IsError: true,
          seconds: 15,
        });
      } finally {
        this.isBusy = false;
      }
    },

    filterGrid(row: any) {
      return GridUtil.filterGrid(row, this.textFilter);
    },

    showAddListView() {
      this.formIsValid = false;
      this.listName = "";
      this.activeView = "ADD_LIST";
    },

    showDefaultView() {
      this.activeView = "DEFAULT";
    },
  },
});
